/* 
 * NGTVariableManager.js
 * Created on 2-jan-2017
 * @author Swen Meeuwes for &ranj
 */

import Solver from "../../../../../../shared/lib/html5-software-library/src/ranj/eng/game/Solver";
import NGTVariableEvent from "./NGTVariableEvent";

export default class NGTVariableManager extends Solver {
    constructor(dispatcher) {
        super();
        this._dispatcher = dispatcher;
    }

    setVariable(variable, value, operator) {
        const changedVariable = super.setVariable(variable, value, operator);

        const variableEvent = new NGTVariableEvent(NGTVariableEvent.VARIABLE_CHANGED, variable, value, operator);
        this._dispatcher.dispatch(variableEvent.type, { data: variableEvent });

        // Return value obtained from solver.setVariable => This is the new value of the variable
        return changedVariable;
    }
}

